import {BACKEND_API, serialize} from '../middleware/backend'

export const FILES_REQUEST = 'FILES_REQUEST';
export const FILES_SUCCESS = 'FILES_SUCCESS';
export const FILES_FAILURE = 'FILES_FAILURE';
export const FILES_COUNT_REQUEST = 'FILES_COUNT_REQUEST';
export const FILES_COUNT_SUCCESS = 'FILES_COUNT_SUCCESS';
export const FILES_COUNT_FAILURE = 'FILES_COUNT_FAILURE';
export const FILE_REQUEST = 'FILE_REQUEST';
export const FILE_SUCCESS = 'FILE_SUCCESS';
export const FILE_FAILURE = 'FILE_FAILURE';
export const FILE_SAVE_REQUEST = 'FILE_SAVE_REQUEST';
export const FILE_SAVE_SUCCESS = 'FILE_SAVE_SUCCESS';
export const FILE_SAVE_FAILURE = 'FILE_SAVE_FAILURE';
export const FILE_INFO_REQUEST = 'FILE_INFO_REQUEST';
export const FILE_INFO_SUCCESS = 'FILE_INFO_SUCCESS';
export const FILE_INFO_FAILURE = 'FILE_INFO_FAILURE';

export const loadFiles = (filter) => (dispatch, getState) => {
	return dispatch({
		[BACKEND_API]: {
			types: [FILES_REQUEST, FILES_SUCCESS, FILES_FAILURE],
			endpoint: "file/list",
			filter: filter
		}
	})
};

export const countFiles = (filter) => (dispatch, getState) => {
	return dispatch({
		[BACKEND_API]: {
			types: [FILES_COUNT_REQUEST, FILES_COUNT_SUCCESS, FILES_COUNT_FAILURE],
			endpoint: "file/count",
			filter: filter
		}
	})
};

export const loadFile = (id) => (dispatch, getState) => {
	return dispatch({
		id: id,
		[BACKEND_API]: {
			types: [FILE_REQUEST, FILE_SUCCESS, FILE_FAILURE],
			endpoint: `file/${id}`,
		}
	})
};

export const saveFile = (item, file) => (dispatch, getState) => {

	const formData = new FormData()
	formData.append('file', file);
	formData.append('item', serialize(item))

	return dispatch({
		id: file.fileId,
		file: file,
		[BACKEND_API]: {
			types: [FILE_SAVE_REQUEST, FILE_SAVE_SUCCESS, FILE_SAVE_FAILURE],
			endpoint: 'file',
			body: formData,
			silent: true
		}
	})
};

export const loadFileInfo = (id) => (dispatch, getState) => {
	return dispatch({
		id: id,
		[BACKEND_API]: {
			types: [FILE_INFO_REQUEST, FILE_INFO_SUCCESS, FILE_INFO_FAILURE],
			endpoint: `file/info/${id}`,
		}
	})
};



// WEBPACK FOOTER //
// ./src/actions/files.js